import { init, track } from '@plausible-analytics/tracker/plausible.js'

import { webAppState } from '@/appState'
import { normalizePlausiblePathname } from '@/utils/plausible/normalizePlausiblePathname'

let initialized = false

const initializePlausible = () => {
    if (initialized) {
        return true
    }

    if (typeof window === 'undefined' || typeof ResizeObserver === 'undefined') {
        return false
    }

    init({
        domain: 'app.campai.com',
        autoCapturePageviews: false,
    })
    initialized = true
    return true
}

export const trackPageViews = (pathname: string) => {
    if (webAppState.isDevelopment || !webAppState.organization || webAppState.isLocalhost) {
        return
    }

    if (!initializePlausible()) {
        return
    }

    const path = normalizePlausiblePathname(pathname, webAppState.organization!.name)
    const url = `${window.location.origin}/${path}`
    track('pageview', { url })
}
